import React, { useEffect, useState } from 'react'
import classNames from 'classnames'
import { Popover } from 'antd'
import { isFunction } from '../../utils/type'
import Tooltip from '../../baseComponent/tooltip'
import Icon from '../icon'
import globalData from '../../common/globalData'
import './index.less'

// eslint-disable-next-line no-shadow
export enum FIRST_TOOLTIP_TYPE{
  LEFT = 'LEFT',
  RIGHT = 'RIGHT'
}

type TFIRST_TOOLTIP = {
  children: any,
  contentWidth?:number | string,
  keyValue:number | string,
  text: string,
  getPopupContainer?:any,
  placement?:any,
  type?:FIRST_TOOLTIP_TYPE,
  onClose?:any,
  visible?:number,
}

export default ({
  children,
  text,
  contentWidth,
  keyValue,
  getPopupContainer,
  placement,
  type = FIRST_TOOLTIP_TYPE.RIGHT,
  onClose,
  visible = 0,
}:TFIRST_TOOLTIP) => {
  const [_visible, setVisible] = useState(0)

  useEffect(() => {
    if (!keyValue) {
      setVisible(visible)
    }
  }, [visible])

  const _onClose = (e) => {
    e.stopPropagation()
    if (keyValue) {
      globalData.set(keyValue, 0)
    }
    setVisible(0)
    onClose?.()
  }

  const content = (<div className="MNfirstTooltipContent" style={{ width: contentWidth }}>
    {
      type === FIRST_TOOLTIP_TYPE.LEFT && <div className="MNfirstTooltipContentCloseLeft" onClick={_onClose}>
        <Icon type="m-guanbi" />
      </div>
    }
    {text}
    {
      type === FIRST_TOOLTIP_TYPE.RIGHT && <div className="MNfirstTooltipContentClose" onClick={_onClose}>
        <Icon type="m-guanbi" />
      </div>
    }
  </div>)

  useEffect(() => {
    if (keyValue) {
      globalData.get(keyValue, setVisible, 1)
    }
  }, [])

  return <Popover
    open={!!_visible}
    content={content}
    trigger="click"
    overlayClassName={classNames('MNfirstTooltip')}
    getPopupContainer={getPopupContainer}
    placement={placement}
  >
    {isFunction(children) ? children({
      onClose: _onClose
    }) : children}
  </Popover>
}

type TFIRST_NORMAL_TIP = {
  children: React.ReactChild,
  keyValue:number | string,
  title: string,
  firstTitle?:string,
  getPopupContainer?:any,
  placement?:any,
}

export const FirstNormalTip = ({
  children,
  keyValue,
  firstTitle,
  title,
  getPopupContainer,
  placement,
} :TFIRST_NORMAL_TIP) => {
  const [visible, setVisible] = useState(0)
  const [firstVisible, setFirstVisible] = useState(0)

  useEffect(() => {
    globalData.get(keyValue, setFirstVisible, 1)
  }, [])

  return <Tooltip
    title={firstVisible ? firstTitle || title : title}
    open={visible || firstVisible}
    onOpenChange={(vis) => {
      setFirstVisible(0)
      if (!vis) {
        globalData.set(keyValue, 0)
      }
      setVisible(vis)
    }}
    overlayClassName={firstVisible && 'MNFirstNormalTip'}
    getPopupContainer={getPopupContainer}
    placement={placement}
  >
    {children}
  </Tooltip>
}
